/* fg-match — "Find similar" (bron: /opt/fg/designer-match/theme/assets/fg-match.js, 3 nov 2026).
   Bezoeker typt een parfumnaam; de Worker geeft alleen FG-handles terug; kaarten komen uit /products/<handle>.js.
   Er staat geen enkele naam van een ander huis in de pagina: alleen wat de bezoeker zelf typt, client-side. */
(function () {
  'use strict';
  if (window.__fgm) return; window.__fgm = 1;
  var d = document;
  function el(tag, cls, txt) { var e = d.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function money(c, cur, loc) {
    try { return new Intl.NumberFormat(loc || undefined, { style: 'currency', currency: cur || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + (cur || ''); }
  }
  function img(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function init(root) {
    if (root.__fgmInit) return; root.__fgmInit = 1;
    var T = {}; try { T = JSON.parse(root.querySelector('[data-fgm-t]').textContent); } catch (e) {}
    var api = root.getAttribute('data-api'), lang = root.getAttribute('data-l') || 'en';
    var base = (root.getAttribute('data-root') || '/').replace(/\/?$/, '/');
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var loc = d.documentElement.lang || lang;
    var form = root.querySelector('[data-fgm-form]'), input = form.querySelector('input'), out = root.querySelector('[data-fgm-out]');
    var qid = null, busy = false;

    function send(t, h) {
      try {
        var b = JSON.stringify({ qid: qid, t: t, h: h || null, l: lang });
        fetch(api + '/e', { method: 'POST', body: b, keepalive: true, mode: 'cors', headers: { 'content-type': 'text/plain' } }).catch(function () {});
      } catch (e) {}
    }
    function msg(t) { out.textContent = ''; out.appendChild(el('p', 'fgm__msg', t)); }

    function card(p, kind) {
      var a = el('article', 'fgm-card' + (kind === 'uit' ? ' fgm-card--out' : ''));
      var link = el('a', 'fgm-card__link'); link.href = base + 'products/' + p.handle;
      link.addEventListener('click', function () { send('click', p.handle); });
      var fig = el('div', 'fgm-card__img');
      if (p.featured_image) { var im = el('img'); im.loading = 'lazy'; im.alt = p.title; im.width = 300; im.height = 300; im.src = img(p.featured_image, 360); fig.appendChild(im); }
      link.appendChild(fig);
      var body = el('div', 'fgm-card__body');
      body.appendChild(el('p', 'fgm-card__v', p.vendor));
      body.appendChild(el('h3', 'fgm-card__t', p.title));
      if (kind !== 'uit') body.appendChild(el('p', 'fgm-card__tag', T.tag));
      var pr = el('p', 'fgm-card__p');
      pr.appendChild(el('span', null, money(p.price, cur, loc)));
      if (p.compare_at_price && p.compare_at_price > p.price) pr.appendChild(el('s', null, money(p.compare_at_price, cur, loc)));
      body.appendChild(pr);
      link.appendChild(body);
      a.appendChild(link);
      var btnw = el('div', 'fgm-card__btn');
      var isPre = (p.tags || []).some(function (t) { return /^pre-?order/i.test(t); });
      if (kind === 'uit') {
        var n = el('a', 'button button-secondary fgm-btn', T.notify); n.href = base + 'products/' + p.handle;
        n.addEventListener('click', function () { send('notify', p.handle); });
        btnw.appendChild(n);
      } else {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (v && (p.variants || []).length === 1) {
          var b = el('button', 'button fgm-btn', isPre ? T.pre : T.add); b.type = 'button';
          b.addEventListener('click', function () { atc(b, v.id, p.handle); });
          btnw.appendChild(b);
        } else {
          var w = el('a', 'button fgm-btn', T.view); w.href = base + 'products/' + p.handle;
          w.addEventListener('click', function () { send('click', p.handle); });
          btnw.appendChild(w);
        }
      }
      a.appendChild(btnw);
      return a;
    }

    function atc(b, id, h) {
      b.disabled = true;
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; send('atc', h); return fetch(base + 'cart.js').then(function (r2) { return r2.json(); }); })
        .then(function (cart) {
          b.textContent = '✓ ' + T.added;
          var vc = el('a', 'fgm-card__cart', T.viewCart); vc.href = base + 'cart'; b.parentNode.appendChild(vc);
          try { d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'fg-match', data: { source: 'fg-match', itemCount: cart.item_count } } })); } catch (e) {}
        })
        .catch(function () { b.disabled = false; b.textContent = T.err; });
    }

    function grid(list, kind) { var g = el('div', 'fgm__grid'); list.forEach(function (p) { g.appendChild(card(p, kind)); }); return g; }

    function geen() { return el('p', 'fgm__msg', T.none); }

    function run(q, auto) {
      q = (q || '').trim().slice(0, 80);
      if (q.length < 3) { if (!auto) msg(T.short); return; }
      if (busy) return; busy = true;
      if (!auto) msg(T.busy);
      fetch(api + '/match?l=' + encodeURIComponent(lang) + '&q=' + encodeURIComponent(q), { mode: 'cors' })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (j) {
          qid = j.qid;
          if (auto && j.w === 'huis') return [];
          var want = (j.op || []).concat((j.uit || []).map(function (h) { return { h: h, s: 'uit' }; }));
          return Promise.all(want.map(function (x) {
            return fetch(base + 'products/' + x.h + '.js', { headers: { accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { return p ? { p: p, s: x.s } : null; }).catch(function () { return null; });
          }));
        })
        .then(function (rows) {
          busy = false;
          rows = rows.filter(Boolean);
          var direct = [], sim = [], uit = [];
          rows.forEach(function (r) {
            if (!r.p.available) uit.push(r.p);
            else if (r.s === 'sim') sim.push(r.p); else direct.push(r.p);
          });
          if (auto && !direct.length && !sim.length) { root.hidden = true; return; }
          root.hidden = false;
          out.textContent = '';
          if (direct.length) out.appendChild(grid(direct.slice(0, 8), 'op'));
          if (sim.length) { out.appendChild(el('h3', 'fgm__sub', T.more)); out.appendChild(grid(sim.slice(0, Math.max(0, 8 - direct.length) || 4), 'op')); }
          if (uit.length && direct.length + sim.length < 4) { out.appendChild(el('h3', 'fgm__sub', T.soon)); out.appendChild(grid(uit.slice(0, 4), 'uit')); }
          if (!direct.length && !sim.length) out.appendChild(geen());
        })
        .catch(function () { busy = false; if (auto) { root.hidden = true; return; } msg(T.err); });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); run(input.value, false); });
    var pre = root.getAttribute('data-q');
    if (pre) { input.value = pre; run(pre, true); }
  }

  function boot() { [].forEach.call(d.querySelectorAll('[data-fgm]'), init); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', boot);
})();
